import React from "react";
import { TableColumn } from "./types";
import { formatDate, capitalizeWord, truncateText } from "./utils";
import { ActionMenuIcon } from "./ActionMenuIcon";

/**
 * Table column configurations for different project types
 */

export const CARBON_PROJECT_COLUMNS: TableColumn[] = [
  {
    key: "actions",
    label: " ",
    width: "40px",
    render: () => <ActionMenuIcon />,
  },
  {
    key: "project_id",
    label: "Project ID",
    render: (value) => value || "N/A",
  },
  {
    key: "name",
    label: "Name",
    minWidth: "300px",
    render: (value) => <span className="text-primaryPurple-100">{value || "N/A"}</span>,
  },
  {
    key: "proponent_name",
    label: "Proponent",
    render: (value) => value || "N/A",
  },
  {
    key: "project_type",
    label: "Project Type",
    render: (value) => value || "N/A",
  },
  {
    key: "description",
    label: "Description",
    minWidth: "500px",
    render: (value) => (
      <div title={value} className="cursor-pointer">
        {truncateText(value, 15) || "N/A"}
      </div>
    ),
  },
  {
    key: "credit_period_start_date",
    label: "Credit Period Start",
    render: (value) => formatDate(value) || "Not available",
  },
  {
    key: "credit_period_end_date",
    label: "Credit Period End",
    render: (value) => formatDate(value) || "Not available",
  },
  {
    key: "methodology",
    label: "Methodology",
    render: (value) => value || "N/A",
  },
  {
    key: "status",
    label: "Status",
    render: (value) => value || "N/A",
  },
  {
    key: "estimated_annual_emission_reduction",
    label: "Estimated Annual Credits",
    render: (value) => value || "N/A",
  },
  {
    key: "registry",
    label: "Registry",
    render: (value) => value || "N/A",
  },
  {
    key: "country",
    label: "Country",
    render: (value) => value || "N/A",
  },
];

export const RECOMMENDATION_PROJECT_COLUMNS: TableColumn[] = [
  {
    key: "actions",
    label: " ",
    width: "40px",
    render: () => <ActionMenuIcon />,
  },
  {
    key: "id",
    label: "Project ID",
    width: "110px",
    render: (value) => <span className="truncate">{value ?? "-"}</span>,
  },
  {
    key: "displayName",
    label: "Name",
    minWidth: "300px",
    render: (_, item) => (
      <span className="text-primaryPurple-100">
        {`${capitalizeWord(
          item?.aggregated ? item.adm_name : item?.adm2 ?? "-",
        )} - ${capitalizeWord(item.type)} ${
          item.total_area ? `${Math.round(item.total_area * 6.5)} Ha` : ""
        } Project`}
      </span>
    ),
  },
  {
    key: "project_type",
    label: "Project Type",
    render: () => "AFOLU",
  },
  {
    key: "location",
    label: "Description",
    minWidth: "300px",
    render: (_, item) => `${item.adm2 ?? item.adm_name ?? "-"} - ${item.country}`,
  },
  {
    key: "crediting_period",
    label: "Crediting Period",
    render: () => "40 - 80 years",
  },
  {
    key: "methodology",
    label: "Methodology",
    render: () => "VM0033",
  },
  {
    key: "status",
    label: "Status",
    render: () => "Concept",
  },
  {
    key: "estimated_credits",
    label: "Estimated Annual Credits",
    render: (_, item) => (item.total_area ? Math.round(item.total_area * 6.5) : "-"),
  },
  {
    key: "registry",
    label: "Registry",
    render: () => "Verra, GS",
  },
  {
    key: "country",
    label: "Country",
    render: (_, item) => item?.country || "-",
  },
];

export const FORESTATION_PROJECT_COLUMNS: TableColumn[] = [
  {
    key: "country",
    label: "Country",
    render: (_, item) => <span className="text-primaryPurple-100">{item?.country || "N/A"}</span>,
  },
  {
    key: "adm1",
    label: "State",
    render: (_, item) => item?.adm1 || "N/A",
  },
  {
    key: "adm2",
    label: "District",
    render: (_, item) => item?.adm2 || "N/A",
  },
  {
    key: "area",
    label: "Area",
    render: (_, item) => item?.area || "N/A",
  },
];

export const SAVED_PROJECT_COLUMNS: TableColumn[] = [
  {
    key: "actions",
    label: " ",
    width: "40px",
    render: () => <ActionMenuIcon />,
  },
  {
    key: "id",
    label: "ID",
    render: (value) => value || "N/A",
  },
  {
    key: "name",
    label: "Name",
    minWidth: "300px",
    render: (value) => <span className="text-primaryPurple-100">{value || "N/A"}</span>,
  },
  {
    key: "project_type",
    label: "Project type",
    render: (value) => value || "N/A",
  },
];
